import { type z } from 'zod';

import { makeListQuery } from '../../common/list-query/list-query';

/**
 * The member's own blocked list.
 *
 * **No filters at all**, and that is the finished design rather than a stub. The
 * list is the member's own, bounded by their own decisions, and it is read from
 * the top: there is nothing to filter by that they do not already know, and a
 * search box over the people you are avoiding is a control nobody wants.
 * Pagination is still shared, because a list with no ceiling needs one.
 */
export const BlocksListQuerySchema = makeListQuery({});

export type BlocksListQuery = z.infer<typeof BlocksListQuerySchema>;
